export default "/images/vendor/@coreui/icons/svg/flag/cif-ni.svg?bf1cb868c711fcd81e91e6f2e6c585b7";